<template>
  <div id="pageDashboard">
    <v-container grid-list-xl fluid>
      <v-label>Today Trackings</v-label>
      <v-layout row wrap>
        <!-- mini statistic start -->
        <v-flex lg3 sm6 xs12>
          <mini-statistic
            icon="fa fa-user"
            :title="String(today.students)"
            sub-title="Students"
            color="blue"
          >
          </mini-statistic>
        </v-flex>
        <v-flex lg3 sm6 xs12>
          <mini-statistic
            icon="fa fa-user"
            :title="String(today.staff)"
            sub-title="Staff"
            color="indigo"
          >
          </mini-statistic>
        </v-flex>
        <v-flex lg3 sm6 xs12>
          <mini-statistic
            icon="fa fa-user"
            :title="String(today.visitors)"
            sub-title="Visitors"
            color="pink"
          >
          </mini-statistic>
        </v-flex>
        <v-flex lg3 sm6 xs12>
          <mini-statistic
            icon="fa fa-user"
            :title="String(today.contractors)"
            sub-title="Contractors"
            color="green"
          >
          </mini-statistic>
        </v-flex>
        <!-- mini statistic  end -->
        <v-flex lg8 sm12 xs12>
          <v-widget title="Weekly Report" content-bg="white">
            <v-btn icon slot="widget-header-action">
              <v-icon class="text--secondary" @click="showAttendanceCount()"
                >refresh</v-icon
              >
            </v-btn>
            <div slot="widget-content">
              <e-chart
                v-if="showChart"
                :path-option="[
                  ['dataset.source', attendances],
                  [
                    'color',
                    [
                      color.blue.base,
                      color.indigo.base,
                      color.pink.base,
                      color.green.base
                    ]
                  ],
                  ['legend.show', true],
                  ['xAxis.axisLabel.show', true],
                  ['yAxis.axisLabel.show', true],
                  ['grid.left', '2%'],
                  ['grid.bottom', '5%'],
                  ['grid.right', '3%'],
                  ['series[0].type', 'bar'],
                  ['series[0].areaStyle', {}],
                  ['series[0].smooth', true],
                  ['series[1].smooth', true],
                  ['series[1].type', 'bar'],
                  ['series[1].areaStyle', {}],
                  ['series[2].smooth', true],
                  ['series[2].type', 'bar'],
                  ['series[2].areaStyle', {}],
                  ['series[3].smooth', true],
                  ['series[3].type', 'bar'],
                  ['series[3].areaStyle', {}]
                ]"
                height="400px"
                width="100%"
              >
              </e-chart>
            </div>
          </v-widget>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-widget title="Attendance" content-bg="white">
            <div slot="widget-content">
              <e-chart
                v-if="showChart"
                :path-option="[
                  ['dataset.source', locationData],
                  ['legend.bottom', '0'],
                  [
                    'color',
                    [
                      color.lightBlue.base,
                      color.indigo.base,
                      color.pink.base,
                      color.green.base,
                      color.cyan.base,
                      color.teal.base
                    ]
                  ],
                  ['xAxis.show', false],
                  ['yAxis.show', false],
                  ['series[0].type', 'pie'],
                  ['series[0].avoidLabelOverlap', true],
                  ['series[0].radius', ['50%', '70%']]
                ]"
                height="400px"
                width="100%"
              >
              </e-chart>
            </div>
          </v-widget>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <plain-table-emergency></plain-table-emergency>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <plain-table></plain-table>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <plain-table-resources></plain-table-resources>
        </v-flex>
        <v-flex> </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import API from "@/api";
import EChart from "@/components/chart/echart";
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic";
import PlainTable from "@/components/widgets/list/PlainTable";
import PlainTableResources from "@/components/widgets/list/PlainTableResources";
// import PlainTableAssets from "@/components/widgets/list/PlainTableAssets";
import PlainTableEmergency from "@/components/widgets/list/PlainTableEmergency";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import APIDashboard from "@/mixins/APIDashboard";
export default {
  components: {
    VWidget,
    MiniStatistic,
    EChart,
    PlainTable,
    // PlainTableAssets,
    PlainTableEmergency,
    PlainTableResources
  },
  mixins: [APIDashboard],
  data: () => ({
    color: Material,
    selectedTab: "tab-1",
    showChart: false,
    today: {
      students: 0,
      staff: 0,
      visitors: 0,
      contractors: 0
    },
    locationData: [],
    attendances: []
  }),
  computed: {
    activity() {
      return API.getActivity();
    },
    posts() {
      return API.getPost(3);
    }
  },
  created() {
    this.showAttendanceCount();
    this.showEmergencyCount();
    this.showGroupAttendanceCount();
    this.showResourcesCount();
    this.showAssetsCount();
  },
  methods: {
    setAttendanceData: function(students, staff, visitors, contractors) {
      let data = [
        {
          value: students,
          name: "Students"
        },
        {
          value: staff,
          name: "Staff"
        },
        {
          value: visitors,
          name: "Visitors"
        },
        {
          value: contractors,
          name: "Contractors"
        }
      ];
      this.locationData = data;
    },
    showAttendanceCount: async function() {
      try {
        let data = await this.getAttendanceCount("", 1);
        console.log(data);
        if (!data.chart_data || data.chart_data.length === 0) {
          return;
        }

        let date = new Date();
        var dataSet = {};
        for (let idx = 0; idx < 7; idx++) {
          dataSet[
            new Date(
              date.getFullYear(),
              date.getMonth(),
              date.getDate() - idx
            ).toLocaleDateString()
          ] =
            data.chart_data.filter(ob => {
              let dt = String(date.getDate() - idx);
              return ob._id === dt;
            }) || {};
        }

        let attendancesraw = [];
        for (let item of Object.keys(dataSet)) {
          let obj = dataSet[item];
          if (obj.length > 0) {
            obj = obj[0];
            await attendancesraw.push({
              day: item,
              Students: obj.student_count || 0,
              Staff: obj.staff_count || 0,
              Visitors: obj.visitor_count || 0,
              Contractors: obj.contractor_count || 0
            });
          } else {
            await attendancesraw.push({
              day: item,
              Students: 0,
              Staff: 0,
              Visitors: 0,
              Contractors: 0
            });
          }
        }
        this.attendances = attendancesraw;

        // this.today.students = data.chart_data[0].student_count || 0;
        this.today.students = attendancesraw[0].Students || 0;
        // if (this.today.students < 10) {
        //   this.today.students = "0" + this.today.students;
        // }
        this.today.staff = attendancesraw[0].Staff || 0;
        // this.today.staff = data.chart_data[0].staff_count || 0;
        // if (this.today.staff < 10) {
        //   this.today.staff = "0" + this.today.staff;
        // }
        this.today.visitors = attendancesraw[0].Visitors || 0;
        // this.today.visitors = data.chart_data[0].visitor_count || 0;
        // if (this.today.visitors < 10) {
        //   this.today.visitors = "0" + this.today.visitors;
        // }
        this.today.contractors = attendancesraw[0].Contractors || 0;
        // this.today.contractors = data.chart_data[0].contractor_count || 0;
        // if (this.today.contractors < 10) {
        //   this.today.contractors = "0" + this.today.contractors;
        // }

        this.setAttendanceData(
          this.today.students,
          this.today.staff,
          this.today.visitors,
          this.today.contractors
        );

        this.showChart = true;
      } catch (error) {
        console.log(error);
      }
    },
    showEmergencyCount: async function() {
      try {
        let data = await this.getEmergencyCount(1);
        console.log(data);
      } catch (error) {
        console.log(error);
      }
    },
    showGroupAttendanceCount: function() {
      try {
        let data = this.getGroupAttendanceCount("", 1);
        console.log(data);
      } catch (error) {
        console.log(error);
      }
    },
    showResourcesCount: function() {
      try {
        let data = this.getResourcesCount("", 1);
        console.log(data);
      } catch (error) {
        console.log(error);
      }
    },
    showAssetsCount: function() {
      try {
        let data = this.getAssetsCount("", 1);
        console.log(data);
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
